export const getAvailableLanguages = () => {
  return ['pt', 'en', 'es'];
};
